var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 328.8 110.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#f8991d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo_mot_hvit_BG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Enso_logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Positiv"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.2,74.48c.8,13.6,12.8,25.6,27.2,25.6,16.16,0,24.8-12.8,24.8-12.8l7.2,7.2s-11.2,16-32,16S0,92.88,0,70.48s17.6-40,37.6-40c20.8,0,36.8,16,36.8,38.41a21.44,21.44,0,0,1-.8,5.76Zm0-9.6h52c-1.6-13.61-12-24-25.6-24S12.8,52.07,11.2,64.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.6,43.27a30.24,30.24,0,0,1,24.8-12.8c18.4,0,31.2,12.8,31.2,32.8v45.61H150.4V63.27c0-13.6-8.8-22.4-20.8-22.4-13.6,0-24,10.4-24,25.61v42.4H94.4V32.07h11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.6,48.87a21.23,21.23,0,0,0-16.8-8c-8.8,0-14.4,5.6-14.4,11.2,0,16.81,41.6,8,41.6,35.21,0,12.8-10.4,23.2-28,23.2-19.2,0-28-13.6-28-13.6l8-8s7.2,11.2,20,11.2c11.2,0,16.8-5.6,16.8-12.8,0-17.6-41.6-8.8-41.6-35.21,0-11.2,10.4-21.6,25.6-21.6a34,34,0,0,1,24.8,10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.6,30.47c21.6,0,39.2,17.6,39.2,40s-17.6,40-39.2,40-39.2-17.6-39.2-40S268,30.47,289.6,30.47Zm0,10.4c-15.2,0-28,12.8-28,29.61,0,16.64,12.8,29.6,28,29.6s28-12.8,28-29.6S304.8,40.87,289.6,40.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 261.6,
    width: 56,
    height: 10
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.a435bab4f5c34d7641f4a3793661b7f6.svg";
export { ForwardRef as ReactComponent };